/**
 * FAQ Accordion Animation Logic
 */

document.addEventListener("DOMContentLoaded", () => {
	if (typeof gsap === "undefined") {
		console.warn("GSAP not found. FAQ animation skipped.");
		return;
	}

    gsap.registerPlugin(ScrollTrigger);

	const accordions = document.querySelectorAll('.osmerova-faq-section[data-gsap="faq-accordion"]');

	accordions.forEach((accordion) => {

        // --- Separator Line Animation ---
        const separators = accordion.querySelectorAll('.faq-separator');
        if (separators.length > 0) {
            gsap.to(separators, {
                width: "100%",
                duration: 0.8,
                ease: "power2.out",
                stagger: 0.1,
                scrollTrigger: {
                    trigger: accordion,
                    start: "top 80%",
                }
            });
        }

        // --- Item Logic (Hover & Click) ---
        const items = accordion.querySelectorAll('.osmerova-faq-item');

        items.forEach(item => {
            const trigger = item.querySelector('.faq-trigger');
            const content = item.querySelector('.faq-content');
            const contentInner = item.querySelector('.faq-content-inner');

            // Define Padding Values
            const defaultPadding = "0rem";
            const activePadding = "1rem";

            // --- Hover Logic ---
            item.addEventListener('mouseenter', () => {
                // Always animate to active padding on hover
                gsap.to([trigger, contentInner], {
                    paddingLeft: activePadding,
                    paddingRight: activePadding,
                    duration: 0.1,
                    ease: "power2.out"
                });
            });

            item.addEventListener('mouseleave', () => {
                // Only revert padding if item is NOT open
                if (!item.classList.contains('is-open')) {
                    gsap.to([trigger, contentInner], {
                        paddingLeft: defaultPadding,
                        paddingRight: defaultPadding,
                        duration: 0.1,
                        ease: "power2.out"
                    });
                }
            });

            // --- Click Logic ---
            trigger.addEventListener('click', () => {
                const isOpen = item.classList.contains('is-open');

                // 1. Close all OTHER items
                items.forEach(otherItem => {
                    if (otherItem !== item && otherItem.classList.contains('is-open')) {
                        const otherTrigger = otherItem.querySelector('.faq-trigger');
                        const otherContent = otherItem.querySelector('.faq-content');
                        const otherInner = otherItem.querySelector('.faq-content-inner');

                        // Remove classes
                        otherItem.classList.remove('is-open');
                        otherTrigger.classList.remove('is-active');

                        // Animate closed
                        gsap.to(otherContent, {
                            height: 0,
                            duration: 0.4,
                            ease: "power2.out"
                        });

                        // Revert padding
                        gsap.to([otherTrigger, otherInner], {
                            paddingLeft: defaultPadding,
                            paddingRight: defaultPadding,
                            duration: 0.3,
                            ease: "power2.out"
                        });
                    }
                });

                // 2. Toggle CURRENT item
                if (!isOpen) {
                    // Open
                    item.classList.add('is-open');
                    trigger.classList.add('is-active');

                    gsap.to(content, {
                        height: "auto",
                        duration: 0.4,
                        ease: "power2.out"
                    });

                    // Ensure padding is set (redundant if hovered, but safe for touch/fast clicks)
                    gsap.to([trigger, contentInner], {
                        paddingLeft: activePadding,
                        paddingRight: activePadding,
                        duration: 0.3,
                        ease: "power2.out"
                    });

                } else {
                    // Close (Optional: if you want toggle behavior. Usually accordions allow closing self)
                    item.classList.remove('is-open');
                    trigger.classList.remove('is-active');

                    gsap.to(content, {
                        height: 0,
                        duration: 0.4,
                        ease: "power2.out"
                    });

                    // Revert padding ONLY if mouse is not hovering?
                    // Spec says: "klikne na novú položku a stará položka sa zavrie a padding sa vráti"
                    // It doesn't explicitly say what happens if I close the current item while hovering.
                    // But standard logic: if I'm hovering, keep padding.
                    // Let's check hover state via matches(':hover')

                    if (!item.matches(':hover')) {
                         gsap.to([trigger, contentInner], {
                            paddingLeft: defaultPadding,
                            paddingRight: defaultPadding,
                            duration: 0.3,
                            ease: "power2.out"
                        });
                    }
                }
            });
        });
	});
});
